if (!customElements.get('thinkcar-drag-scroll')) {
  customElements.define('thinkcar-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('slider-element, [data-drag-scroll-container]');
      if (!this.scroller || this.initialized) return;
      this.initialized = true;
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('dragstart', this.onDragStart);
      this.addEventListener('click', this.onClick, true);
      if (this.hasAttribute('wheel-scroll')) this.addEventListener('wheel', this.onWheel, { passive: false });
    }

    disconnectedCallback() {
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('dragstart', this.onDragStart);
      this.removeEventListener('click', this.onClick, true);
      this.removeEventListener('wheel', this.onWheel);
      this.stopDragging();
      this.initialized = false;
    }

    get desktopDisabled() {
      return this.hasAttribute('disable-desktop') && window.matchMedia('(min-width: 1024px)').matches;
    }

    onPointerDown = (event) => {
      if (this.desktopDisabled || event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('iframe, input, select, textarea')) return;
      this.dragging = true;
      this.moved = false;
      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScrollLeft = this.scroller.scrollLeft;
      this.scroller.style.scrollBehavior = 'auto';
      this.scroller.style.scrollSnapType = 'none';
      window.addEventListener('pointermove', this.onPointerMove, { passive: false });
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);
    };

    onPointerMove = (event) => {
      if (!this.dragging || event.pointerId !== this.pointerId) return;
      const distance = event.clientX - this.startX;
      if (Math.abs(distance) <= 5) return;
      this.moved = true;
      this.classList.add('is-dragging');
      this.scroller.scrollLeft = this.startScrollLeft - distance;
      event.preventDefault();
    };

    onPointerUp = (event) => {
      if (!this.dragging || event.pointerId !== this.pointerId) return;
      this.blockClick = this.moved;
      this.stopDragging();
      window.setTimeout(() => { this.blockClick = false; }, 0);
    };

    stopDragging = () => {
      this.dragging = false;
      this.classList.remove('is-dragging');
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
      if (this.scroller) {
        this.scroller.style.removeProperty('scroll-behavior');
        this.scroller.style.removeProperty('scroll-snap-type');
      }
    };

    onDragStart = (event) => {
      if (this.dragging) event.preventDefault();
    };

    onClick = (event) => {
      if (!this.blockClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };

    onWheel = (event) => {
      if (this.desktopDisabled || window.matchMedia('(max-width: 749px)').matches || this.scroller.scrollWidth <= this.scroller.clientWidth) return;
      const horizontalOnly = this.getAttribute('wheel-scroll') === 'horizontal-only';
      let delta;
      if (horizontalOnly) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          delta = event.deltaX;
        } else if (event.shiftKey) {
          delta = event.deltaY;
        } else {
          return;
        }
      } else {
        delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      }
      if (!delta) return;
      const previous = this.scroller.scrollLeft;
      const maximum = this.scroller.scrollWidth - this.scroller.clientWidth;
      const next = Math.max(0, Math.min(maximum, previous + delta));
      if (next === previous) return;
      this.scroller.scrollLeft = next;
      event.preventDefault();
    };
  });
}
